import React, { useState } from "react"
import PropTypes from "prop-types"

import Modal from "shared/components/modal"
import classNames from "classnames"

import "./index.scss"

const FeatureToggleManagement = ({ toggles }) => {
  const [warningVisible, setWarningVisible] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [featureToggles, updateFeatureToggles] = useState(toggles)

  const onToggleClick = key => {
    return fetch(`/feature_toggle/${key}`, {
      headers: { "Content-Type": "application/json" },
    })
      .then(response => response.json())
      .then(result => {
        if (result.status === "ok") {
          updateFeatureToggles({
            ...featureToggles,
            [key]: !featureToggles[key],
          })
          window.appendFlash(
            `Feature toggle ${key} updated. Reload to see changes!`
          )
        } else {
          console.error(key, result.error)
          window.appendFlash("Error to update feature toggle", "danger")
        }
      })
  }

  return (
    <>
      <section
        styleName={classNames("feature-toggles-warning", {
          visible: warningVisible,
        })}
        onMouseOver={() => setWarningVisible(true)}
        onMouseLeave={() => setWarningVisible(false)}
        onClick={() => setModalVisible(!modalVisible)}
      >
        <span>Manage feature toggles</span>
      </section>

      <Modal show={modalVisible} closeListener={() => setModalVisible(false)}>
        <div styleName="feature-toggles-modal">
          <h1>Feature toggles availables</h1>
          <ul>
            {Object.entries(featureToggles).map(([key, status]) => (
              <li key={key}>
                <a onClick={() => onToggleClick(key)}>
                  {key}:{" "}
                  <span styleName={classNames({ enabled: status })}>
                    {status ? "enabled" : "disabled"}
                  </span>
                </a>
              </li>
            ))}
          </ul>
          <p>Click in the status to change it.</p>
        </div>
      </Modal>
    </>
  )
}

FeatureToggleManagement.propTypes = {
  toggles: PropTypes.object,
}

FeatureToggleManagement.defaultProps = {
  toggles: {},
}

export default FeatureToggleManagement
